import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgStoring = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Storing_svg__a)">
      <mask
        id="Storing_svg__b"
        width={22}
        height={32}
        x={9}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M21.43 4.5 9 23.17l9.57-.25V35.5L31 17h-9.57z"
        />
      </mask>
      <g mask="url(#Storing_svg__b)">
        <path
          fill="#F18700"
          d="m25.36 39.32-12.25-7.07L20.18 20z"
        />
        <path
          fill="#F7A941"
          d="m.86 25.18 12.25 7.07-7.07 12.24z"
        />
        <path
          fill="#F18700"
          d="m6.04 44.49 7.07-12.24 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="m20.18 20-7.07 12.25L.86 25.18z"
        />
        <path
          fill="#F18700"
          d="M-4.31 5.86 2.76-6.39 15.01.68zM20.18 20 7.93 12.93 15.01.68z"
        />
        <path
          fill="#F7A941"
          d="M15.01.68 7.93 12.93-4.31 5.86zM.86 25.18l7.07-12.25L20.18 20z"
        />
        <path
          fill="#F18700"
          d="m20.18 20 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m25.36 39.32 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="m39.5 14.82-7.07 12.25L20.18 20z"
        />
        <path
          fill="#F7A941"
          d="m44.68 34.14-7.07 12.25-12.25-7.07z"
        />
        <path
          fill="#F18700"
          d="m15.01.68 12.24 7.07L20.18 20z"
        />
        <path
          fill="#F7A941"
          d="M39.5 14.82 27.25 7.75 34.32-4.5z"
        />
        <path
          fill="#F18700"
          d="M34.32-4.5 27.25 7.75 15.01.68zM20.18 20l7.07-12.25 12.25 7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Storing_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgStoring);

export default ForwardRef;
